
import { computed, defineComponent, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'

// realisations
import { invoice_scans } from '@/core/realisations/invoice_scans.realisation'

// validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// composable
import useNotifications from '@/common/composable/useNotifications'

// constants
import { FILES_TYPES } from '@/core/constants/scans.constants'
import { GetInvoiceScanResponseT } from '@/core/types/invoice_scans.types'

export default defineComponent({
    components: {
        PageTitle,
        TheInput,
        TheButton,
        FileReader,
        TheSelect,
    },
    setup() {
        const notifications = useNotifications()

        const state = reactive({
            invoice_number: null as string | null,
            is_loading: false,
            scan: null as string | null,
            delivery_attachment: null as string | null,
            scan_client: null as string | null,
        })

        const upload_state = reactive({
            invoice_number: null as string | null,
            fileType: null as number | null,
            files: [] as File[],
            is_loading: false,
            is_uploaded: false,
        })

        const upload_form$ = useVuelidate(
            { invoice_number: { required }, files: { required }, fileType: { required } },
            upload_state
        )

        const imgPreview = computed(() => {
            if (!upload_state.files.length) return null
            return URL.createObjectURL(upload_state.files[0])
        })

        const isPDF = (url: string) => {
            let extension_tmp = url.split('.')
            return extension_tmp[extension_tmp.length - 1] === 'pdf'
        }

        const processResponse = (response: GetInvoiceScanResponseT) => {
            if (response.data.scan) {
                if (isPDF(response.data.scan)) {
                    window.open(response.data.scan, '_blank')?.focus()
                } else {
                    state.scan = response.data.scan
                }
            }

            if (response.data.scan_client) {
                if (isPDF(response.data.scan_client)) {
                    window.open(response.data.scan_client, '_blank')?.focus()
                } else {
                    state.scan_client = response.data.scan_client
                }
            }

            state.delivery_attachment = response.data.delivery_attachment
        }

        const getScans = async () => {
            if (!state.invoice_number) return

            try {
                state.is_loading = true
                const response = await invoice_scans.getScan(state.invoice_number)

                processResponse(response)
            } catch (error: any) {
                if (!error.length) {
                    notifications.notify({
                        title: 'Нет сканов для накладной!',
                        type: 'danger',
                    })
                }

                notifications.notifyError({
                    error,
                    title: `Ошибка!`,
                })
            } finally {
                state.is_loading = false
            }
        }

        const saveScan = async () => {
            upload_form$.value.$touch()
            if (upload_form$.value.$invalid) return

            if (
                !upload_state.invoice_number ||
                !upload_state.files.length ||
                !upload_state.fileType
            )
                return

            try {
                upload_state.is_loading = true
                await invoice_scans.saveScan(
                    upload_state.invoice_number,
                    upload_state.files[0],
                    upload_state.fileType
                )
                upload_state.is_uploaded = true
            } catch (error) {
                console.error(error)
            } finally {
                upload_state.is_loading = false
            }
        }

        return {
            state,
            upload_state,
            upload_form$,
            imgPreview,
            getScans,
            saveScan,
            //
            FILES_TYPES,
        }
    },
})
